import $api from "../http";
import { IOpenGymReservationsParams } from "../api/types";
import dayjs from "dayjs";
import { IOpenGymReservation } from "../models/OpenGymReservation";

class OpenGymReservationServiceClass {
  getAll(model: IOpenGymReservationsParams) {
    let query = `?fromDate=${dayjs(model.from).format("YYYY-MM-DD")}&toDate=${dayjs(model.to).format("YYYY-MM-DD")}`;
    if (model.searchValue) {
      query += `&searchValue=${model.searchValue}`;
    }
    if (model.userId) {
      query += `&userId=${model.userId}`;
    }
    return $api.get<IOpenGymReservation[]>(`api/open-gym/reservation/all${query}`);
  }

  cancel(reservationId: number, gymListingId: string) {
    return $api.delete<{}>(`api/open-gym/reservation/cancel/${reservationId}`, {
      data: { gymListingId },
    });
  }
}

export const OpenGymReservationService = new OpenGymReservationServiceClass();
